<script>
	import { onMount } from "svelte";
	import { get } from "svelte/store";
	import Feature from "../Branding/Feature";
	import User from "../Branding/User";
	import GeoHelper from "../Helpers/GeoHelper";
	import InputHelper from "../Helpers/InputHelper";
	import LocalStorageHelper from "../Helpers/LocalStorageHelper";
	import AnnotationsStore from "../UI/Annotations/Store";
	import MapControlType from "./Enums/MapControlType";
	import MapDataSource from "./Enums/MapDataSource";
	import MapLayer from "./Enums/MapLayer";
	import MapLayerManager from "./MapLayerManager";
	import MapStore from "./Store";
	
	let control = MapStore.control;
	let customGeojson = MapStore.controlData.customGeojson.layers.input;
	let linePoints = MapStore.controlData.draw.points;
	let customMarkers = MapStore.controlData.draw.markers;

	let mouseTooltip = null;
	let mouseTooltipVisible = false;

	onMount(()=>{
		loadData();
	});

	let loadData = () => {
		const geojsons = JSON.parse(LocalStorageHelper.get("draw.customGeojson", "[]"));
		for(let i = 0; i < geojsons.length; i++) {
			const geojson = geojsons[i];
			MapLayerManager.addCustomGeoJSONLayer(JSON.stringify(geojson));
		}

		const markers = JSON.parse(LocalStorageHelper.get("draw.customMarkers", "[]"));
		$customMarkers = markers;
		MapLayerManager.updateCustomMarkers();


	};
	let saveData = () => {
		try {
			let customGeojsonJSON = JSON.stringify($customGeojson);
			if (customGeojsonJSON.length < 1024 * 1024 < 3) { 
				LocalStorageHelper.set("draw.customGeojson", customGeojsonJSON);
			} else {
				console.warn("GeoJSON could not be saved – it is too large.");
			}
		} catch(e) {
			console.error("GeoJSON could not be saved – exception:");
			console.error(e);
		}

		LocalStorageHelper.set("draw.customMarkers", JSON.stringify($customMarkers));


	};

	let boxPickerVisible = MapStore.controlData.boxPicker.visible;

	let setControl = (e) => {
		const type = e.target.attributes.title.value;
		$control = type;

		const map = MapStore.helpers.getMap();
		if ($control === MapControlType.BOX_SELECT) {
			map.boxZoom.disable();
		}
		else {
			map.boxZoom.enable();
		}

		if ($control == MapControlType.ADD_CUSTOM_GEOJSON) {
			MapStore.controlData.customGeojson.visible.set(true);
		}
		updateMouseTooltip();
	}

	let updateMouseTooltip = () => {
		mouseTooltipVisible = false;
		if (mouseTooltip !== null) {
			if ($control === MapControlType.BOX_SELECT) {
				mouseTooltipVisible = true;
				mouseTooltip.innerHTML = "Click and drag a box to select Vessels.";
			}
			else if ($control === MapControlType.ADD_POLYLINE ||
				$control === MapControlType.ADD_POLYGON) {
				// ADD_POLYGON, ADD_RECTANGLE, ADD_MARKER, DELETE_CUSTOM_GEOJSON
				mouseTooltipVisible = true;

				const drawingNoun = ($control === MapControlType.ADD_POLYLINE)?"line":"shape";
				const drawingFinishPoint = ($control === MapControlType.ADD_POLYLINE)?"last":"first";
				const drawingEndLimiit = ($control === MapControlType.ADD_POLYLINE)?1:2;
				const points = get(MapStore.controlData.draw.points);
				if (points.length == 0) {
					mouseTooltip.innerHTML = "Click to start drawing " +  drawingNoun + ".";
				}
				else if (points.length <= drawingEndLimiit) {
					mouseTooltip.innerHTML = "Click to continue drawing " +  drawingNoun + ".";
				}
				else {
					mouseTooltip.innerHTML = "Click " + drawingFinishPoint + " point to finish " +  drawingNoun + ".";
				}
			}
			else if ($control === MapControlType.ADD_MARKER) {
				mouseTooltipVisible = true;
				mouseTooltip.innerHTML = "Click on map to add marker.";
			}
			else if ($control === MapControlType.DELETE_CUSTOM_GEOJSON) {
				mouseTooltipVisible = true;
				mouseTooltip.innerHTML = "Click on a line/shape to remove.";
			}
			else {
				mouseTooltip.style.left = "-1000px";
				mouseTooltip.style.top = "-1000px";
			}
		}
	}

	let _initialised = false;
	$: {
		$control;
		$linePoints;
		updateMouseTooltip();
	}
	$: {
		$control;
		$linePoints = [];
	}
	$: {
		$customGeojson;
		$customMarkers;
		if (get(MapStore.meta.initialised)) {
			saveData();
		}
	}
	$: {
		$customMarkers;
		MapLayerManager.updateCustomMarkers();
		$boxPickerVisible = false;
	}

	let annotationsVisible = AnnotationsStore.meta.visible;

	MapStore.meta.initialised.subscribe((initialised) => {
		_initialised = initialised;
		if (initialised) {
			const map = MapStore.helpers.getMap();
			map.on("mousemove", (event) => {
				if (mouseTooltipVisible) {
					const current = InputHelper.getMousePos(event.originalEvent, map);
					mouseTooltip.style.left = current.x + "px";
					mouseTooltip.style.top = current.y + "px";
				}
			});
			map.on("mouseover", MapLayer.CUSTOM_DRAW_LINES_POINTS, (event) => {
				map.getCanvas().style.cursor = "pointer";
			});
			map.on("mouseout", MapLayer.CUSTOM_DRAW_LINES_POINTS, (event) => {
				map.getCanvas().style.cursor = "crosshair";
			});
			map.on("mousedown", MapLayer.CUSTOM_DRAW_LINES_POINTS, (event) => {
				event.preventDefault();

				let shouldFinish = false;
				if ($linePoints.length > 2) {
					if (event.features.length > 0) {
						const comparePointIndex = ($control === MapControlType.ADD_POLYLINE)
							? $linePoints.length - 1
							: 0;
						const coords = event.features[0].geometry.coordinates;;
						const foundIndex = GeoHelper.findClosestPointByLngLat($linePoints, coords[0], coords[1]);
						if (foundIndex == comparePointIndex) {
							shouldFinish = true;
						}
					}
				}

				if (shouldFinish) {
					const arrayPoints = GeoHelper.lngLatPointsToArray($linePoints);
					let newFeature = null;
					if ($control === MapControlType.ADD_POLYLINE) {
						newFeature = GeoHelper.featureCollectionLineString(arrayPoints);
					}
					else if ($control === MapControlType.ADD_POLYGON) {
						arrayPoints.push(arrayPoints[0]);
						newFeature = GeoHelper.featureCollectionPolygon(arrayPoints);
					}
					if (newFeature != null) {
						MapLayerManager.addCustomGeoJSONLayer(JSON.stringify(newFeature));
						$control = MapControlType.PAN;
						$linePoints = [];
					}
				}

			});

			// custom layers
			MapStore.controlData.customGeojson.layers.input.subscribe((inputFeatureCollections) => {
				const fillFeatures = [];
				const lineFeatures = [];
				const pointFeatures = [];

				for (let i = 0; i < inputFeatureCollections.length; i++) {
					const fc = inputFeatureCollections[i];
					for (let j = 0; j < fc.features.length; j++) {
						const feature = fc.features[j];
						feature.properties.index = fc.properties.index;
						if (feature.geometry.type === "Polygon") {
							fillFeatures.push(feature);
							lineFeatures.push(feature);
						}
						else if (feature.geometry.type === "LineString") {
							lineFeatures.push(feature);
						}
						else if (feature.geometry.type === "MultiLineString") {
							lineFeatures.push(feature);
						}
						else if (feature.geometry.type === "Point") {
							pointFeatures.push(feature);
						}
						else {
							console.warn("Unsupported Geojson feature: ", feature.geometry.type);
						}
					}
				}
 
				map.getSource(MapDataSource.CUSTOM_GEOJSON_FILLS).setData(GeoHelper.emptyGeoJson(fillFeatures));
				map.getSource(MapDataSource.CUSTOM_GEOJSON_LINES).setData(GeoHelper.emptyGeoJson(lineFeatures));
				// map.getSource(MapDataSource.CUSTOM_GEOJSON_FILLS).setData(fillFeatures);
			});

			// points
			MapStore.controlData.draw.points.subscribe((lngLatPoints) => {
				const arrayPoints = GeoHelper.lngLatPointsToArray(lngLatPoints);

				const lineString = GeoHelper.featureCollectionLineString(arrayPoints);
				map.getSource(MapDataSource.CUSTOM_DRAW_LINES).setData(lineString);

				const points = GeoHelper.featureCollectionPoints(arrayPoints);
				map.getSource(MapDataSource.CUSTOM_DRAW_LINES_POINTS).setData(points);

				map.getSource(MapDataSource.CUSTOM_DRAW_LINES_FILLS).setData(GeoHelper.emptyGeoJson());

				if (get(MapStore.control) === MapControlType.ADD_POLYGON) {
					if (arrayPoints.length >= 2) {
						arrayPoints.push(arrayPoints[0]);
					}
					const polygon = GeoHelper.featureCollectionPolygon(arrayPoints);
					map.getSource(MapDataSource.CUSTOM_DRAW_LINES_FILLS).setData(polygon);
				}
			});
		}
	});



</script>

<style type="text/scss">
	#map-controls {
		position: absolute;
		top: 10px;
		left: 10px;
		color: white;
		text-align: left;
		z-index: 1;
		border-radius: 3px;
		width:30px;
		pointer-events: all;

		button {
			width: 32px;
			height: 32px;
			text-align: center;
			padding: 0;
			margin-bottom: 5px;
			cursor: pointer;

			background-color: var(--mdc-theme-background, white);
			color: var(--mdc-theme-text-primary-on-background, black);

			span {
				font-size: 15pt;
				vertical-align: bottom;
				pointer-events: none;
			}
		}
		button:hover {
			background-color: #eee;
			color: var(--mdc-theme-text-primary-on-background, black);
		}
		button.selected {
			background-color: var(--mdc-theme-secondary);
			color: var(--mdc-theme-on-secondary);
		}
		button.spacer {
			height: 2px;
			background-color: #ddd;
		}

		#mouse-tooltip {
			background-color: #333;
			color: white;
			position: absolute;
			min-width: 100px;
			min-height: 30px;
			top: 0px;
			left: 0px;
			padding: 5px;
			margin-top: -100%;
			margin-left: 20px;
			pointer-events: none;
		}
	}
</style>

{#if _initialised}
	<div id='map-controls'>

		<button class:selected={$control===MapControlType.PAN} title={MapControlType.PAN} on:click={setControl}>
			<span class='material-icons'>pan_tool</span>
		</button>

		<button class:selected={$control===MapControlType.BOX_SELECT} title={MapControlType.BOX_SELECT} on:click={setControl}>
			<span class='material-icons'>check_box_outline_blank</span>
		</button>

		<button class:selected={$control===MapControlType.LNGLAT_PICKER} title={MapControlType.LNGLAT_PICKER} on:click={setControl}>
			<span class='material-icons'>colorize</span>
		</button>

		{#if $boxPickerVisible}
			<button class:selected={$control===MapControlType.BOX_PICKER} title={MapControlType.BOX_PICKER} on:click={setControl}>
				<span class='material-icons'>check_box_outline_blank</span>
			</button>
		{/if}

		{#if User.hasFeature(Feature.ANNOTATIONS.VIEW) && $annotationsVisible }
			<div id="mouse-tooltip" class:hidden={!mouseTooltipVisible} bind:this={mouseTooltip}></div>

			<button class:selected={$control===MapControlType.ADD_POLYLINE} title={MapControlType.ADD_POLYLINE} on:click={setControl}>
				<span class='material-icons'>minimize</span>
			</button>

			<button class:selected={$control===MapControlType.ADD_POLYGON} title={MapControlType.ADD_POLYGON} on:click={setControl}>
				<span class='material-icons'>change_history</span>
			</button>

			<button class:selected={$control===MapControlType.ADD_MARKER} title={MapControlType.ADD_MARKER} on:click={setControl}>
				<span class='material-icons'>room</span>
			</button>

			<button class:selected={$control===MapControlType.ADD_CUSTOM_GEOJSON} title={MapControlType.ADD_CUSTOM_GEOJSON} on:click={setControl}>
				<span class='material-icons'>add</span>
			</button>

			{#if $customGeojson.length > 0 || $customMarkers.length > 0}
				<button class:selected={$control===MapControlType.DELETE_CUSTOM_GEOJSON} title={MapControlType.DELETE_CUSTOM_GEOJSON} on:click={setControl}>
					<span class='material-icons'>clear</span>
				</button>
			{/if}
		{/if}

	</div>

	<!-- create, edit, brush -->
	<!-- <button class='spacer'></button>
	<button><span class='material-icons'>select_all</span></button>
	<button><span class='material-icons'>clear</span></button> -->
	<!-- linear_scale, scatter_plot -->

{/if}

